import React from 'react';
import styled from 'styled-components';
import { LayoutContext } from 'contexts';
import { theme } from 'components';

const Footer: React.FC = () => {
  const { getSiderCurrentWidth, transition, footerHeight, footerVisibility } =
    React.useContext(LayoutContext);

  if (!footerVisibility) return null;

  return (
    <StyledFooter
      $footerHeight={footerHeight}
      $left={getSiderCurrentWidth()}
      $transition={transition}
    >
      <span>{new Date().getFullYear()} &copy; BrokerBay</span>
    </StyledFooter>
  );
};

const StyledFooter = styled.div<{
  $footerHeight: number;
  $left: number;
  $transition: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  padding: 4px 0;
  left: ${({ $left }) => $left}px;
  right: 0;
  bottom: 0;
  height: ${({ $footerHeight }) => $footerHeight}px;
  background-color: ${theme.getColor('background')};
  transition: all ${({ $transition }) => $transition}s;
`;

export default Footer;
